import * as Yup from "yup";
import { VALIDATION_MESSAGES } from ".";

/* Yup validation schema for step1 */
export const getValidationShema = (intl) => {
  const validationShema = Yup.object({
    businessUnit: Yup.string()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    projectName: Yup.string()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    products: Yup.array()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    sector: Yup.string()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    segment: Yup.string()
      .required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    application: Yup.string(),
    applicationByUser: Yup.string(),
    countryProject: Yup.array().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    cityProject: Yup.array().required(intl.formatMessage(VALIDATION_MESSAGES.required)),
    implementationYear: Yup.number().positive(
      intl.locale === "es" ? "Debe ser positivo" : "Must be positive"
    )
  });

  return validationShema;
}
